module.exports = __webpack_public_path__ + "media/images/bg_mv_purchasing_one_room-8511ac069bec364df6e19852650c0366.jpg";